export const getEntities = state => state.get('entities');
